import React, { useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import axios from "../utils/api";
import { useNavigate } from "react-router-dom";

const CreateAdmin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dob, setDob] = useState("");
  const [role, setRole] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateFields = () => {
    const errors = {};

    if (!name.match(/^[a-zA-Z\s]+$/)) {
      errors.name = "Name can only contain letters and spaces";
    }

    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      errors.email = "Invalid email format";
    }

    if (!phoneNumber.match(/^\d{10}$/)) {
      errors.phoneNumber = "Valid phone number is required (10 digits)";
    }

    return errors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validateFields();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        "/register-admin",
        {
          email,
          password,
          name,
          employeeId,
          phoneNumber,
          dob,
          role,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSnackbarMessage(response.data.message);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setEmail("");
      setPassword("");
      setName("");
      setEmployeeId("");
      setPhoneNumber("");
      setDob("");
      setRole("");
      setErrors({});
      setTimeout(() => {
        navigate("/admin-user");
      }, 3000);
    } catch (error) {
      setSnackbarMessage(
        error.response?.data?.message || "An error occurred. Please try again."
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  return (
    <div style={styles.container}>
      <IconButton
        onClick={() => navigate(-1)}
        style={styles.backButton}
      >
        <ArrowBackIcon />
      </IconButton>
      
      <div style={styles.card}>
        <div style={styles.cardHeader}>
          <h1 style={styles.title}>Create Admin</h1>
          <p style={styles.subtitle}>Add a new administrator to the system</p>
        </div>
        
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formRow}>
            <div style={styles.formGroup}>
              <label style={styles.label}>
                <span style={styles.labelIcon}>👤</span>
                Full Name
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={styles.input}
                placeholder="Enter full name"
                className={errors.name ? 'error' : ''}
              />
              {errors.name && <div style={styles.error}>{errors.name}</div>}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>
                <span style={styles.labelIcon}>🆔</span>
                Employee ID
              </label>
              <input
                type="text"
                value={employeeId}
                onChange={(e) => setEmployeeId(e.target.value)}
                style={styles.input}
                placeholder="Enter employee ID"
              />
              {errors.employeeId && <div style={styles.error}>{errors.employeeId}</div>}
            </div>
          </div>

          <div style={styles.formRow}>
            <div style={styles.formGroup}>
              <label style={styles.label}>
                <span style={styles.labelIcon}>📧</span>
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={styles.input}
                placeholder="Enter email address"
                className={errors.email ? 'error' : ''}
              />
              {errors.email && <div style={styles.error}>{errors.email}</div>}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>
                <span style={styles.labelIcon}>📱</span>
                Phone Number
              </label>
              <input
                type="text"
                value={phoneNumber}
                onChange={(e) => {
                  const onlyDigits = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setPhoneNumber(onlyDigits);
                }}
                style={styles.input}
                placeholder="Enter phone number"
                className={errors.phoneNumber ? 'error' : ''}
              />
              {errors.phoneNumber && <div style={styles.error}>{errors.phoneNumber}</div>}
            </div>
          </div>
          
          <div style={styles.formRow}>
            <div style={styles.formGroup}>
              <label style={styles.label}>
                <span style={styles.labelIcon}>🎂</span>
                Date of Birth
              </label>
              <input
                type="date"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
                style={styles.input}
              />
              {errors.dob && <div style={styles.error}>{errors.dob}</div>}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>
                <span style={styles.labelIcon}>⚡</span>
                Role
              </label>
              <div style={styles.selectWrapper}>
                <select
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  style={styles.select}
                >
                  <option value="">Select Role</option>
                  <option value="Hr">HR</option>
                  <option value="ProjectManager">Project Manager</option>
                  <option value="AdminController">Admin Controller</option>
                  <option value="Distributor">Distributor</option>
                </select>
                <span style={styles.selectArrow}>▼</span>
              </div>
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>
              <span style={styles.labelIcon}>🔒</span>
              Password
            </label>
            <div style={styles.passwordContainer}>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={styles.passwordInput}
                placeholder="Enter password"
              />
              <button
                type="button"
                onClick={handleClickShowPassword}
                style={styles.showPasswordButton}
              >
                {showPassword ? "👁️ Hide" : "👁️ Show"}
              </button>
            </div>
            {password.length > 0 && password.length < 8 && (
              <div style={styles.error}>Password must be at least 8 characters</div>
            )}
            <div style={styles.passwordStrength}>
              <div style={{
                ...styles.strengthBar,
                width: password.length >= 8 ? '100%' : password.length > 0 ? `${(password.length/8)*100}%` : '0%',
                backgroundColor: password.length >= 8 ? '#10b981' : password.length > 0 ? '#f59e0b' : '#e5e7eb'
              }} />
            </div>
          </div>

          <button
            type="submit"
            style={styles.submitButton}
          >
            <span style={styles.submitIcon}>✨</span>
            Register Admin
          </button>
        </form>
      </div>

      {snackbarOpen && (
        <div
          style={{
            ...styles.snackbar,
            backgroundColor: snackbarSeverity === "success" ? "#10b981" : "#ef4444",
          }}
        >
          <span style={styles.snackbarIcon}>
            {snackbarSeverity === "success" ? "✅" : "❌"}
          </span>
          {snackbarMessage}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    background:
      "radial-gradient(1200px 600px at 10% 0%, rgba(37, 99, 235, 0.10), rgba(255,255,255,0) 60%), radial-gradient(900px 450px at 90% 15%, rgba(16, 185, 129, 0.10), rgba(255,255,255,0) 55%), #ffffff",
    padding: "20px",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    position: "relative",
    overflow: "hidden",
  },
  backButton: {
    position: "absolute",
    top: "24px",
    left: "24px",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
    zIndex: 10,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 1)",
      transform: "scale(1.05)",
      boxShadow: "0 6px 25px rgba(0, 0, 0, 0.15)",
    },
  },
  card: {
    backgroundColor: "transparent",
    backdropFilter: "none",
    borderRadius: "0px",
    boxShadow: "none",
    padding: "0px",
    width: "100%",
    maxWidth: "1000px",
    animation: "none",
    border: "none",
  },
  cardHeader: {
    textAlign: "center",
    marginBottom: "35px",
  },
  title: {
    color: "#1a1a1a",
    fontSize: "32px",
    fontWeight: "700",
    marginBottom: "8px",
    letterSpacing: "-0.5px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  subtitle: {
    color: "#666",
    fontSize: "16px",
    fontWeight: "400",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  formRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
    "@media (max-width: 640px)": {
      gridTemplateColumns: "1fr",
    },
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    animation: "fadeIn 0.5s ease-out",
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#374151",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  labelIcon: {
    fontSize: "18px",
  },
  input: {
    padding: "12px 16px",
    borderRadius: "12px",
    border: "2px solid #e5e7eb",
    fontSize: "15px",
    transition: "all 0.3s ease",
    backgroundColor: "white",
    "&:focus": {
      outline: "none",
      borderColor: "#667eea",
      boxShadow: "0 0 0 4px rgba(102, 126, 234, 0.1)",
    },
    "&.error": {
      borderColor: "#ef4444",
    },
    "&:hover": {
      borderColor: "#9ca3af",
    },
  },
  selectWrapper: {
    position: "relative",
  },
  select: {
    padding: "12px 16px",
    borderRadius: "12px",
    border: "2px solid #e5e7eb",
    fontSize: "15px",
    backgroundColor: "white",
    appearance: "none",
    width: "100%",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:focus": {
      outline: "none",
      borderColor: "#667eea",
      boxShadow: "0 0 0 4px rgba(102, 126, 234, 0.1)",
    },
    "&:hover": {
      borderColor: "#9ca3af",
    },
  },
  selectArrow: {
    position: "absolute",
    right: "16px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#6b7280",
    pointerEvents: "none",
    fontSize: "12px",
  },
  passwordContainer: {
    display: "flex",
    gap: "10px",
  },
  passwordInput: {
    flex: 1,
    padding: "12px 16px",
    borderRadius: "12px",
    border: "2px solid #e5e7eb",
    fontSize: "15px",
    transition: "all 0.3s ease",
    "&:focus": {
      outline: "none",
      borderColor: "#667eea",
      boxShadow: "0 0 0 4px rgba(102, 126, 234, 0.1)",
    },
  },
  showPasswordButton: {
    padding: "0 20px",
    backgroundColor: "#f3f4f6",
    border: "2px solid #e5e7eb",
    borderRadius: "12px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
    color: "#4b5563",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#e5e7eb",
      borderColor: "#9ca3af",
    },
  },
  passwordStrength: {
    height: "4px",
    backgroundColor: "#e5e7eb",
    borderRadius: "2px",
    marginTop: "4px",
    overflow: "hidden",
  },
  strengthBar: {
    height: "100%",
    transition: "all 0.3s ease",
    borderRadius: "2px",
  },
  error: {
    color: "#ef4444",
    fontSize: "12px",
    fontWeight: "500",
    marginTop: "4px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    "&::before": {
      content: "'⚠️'",
      fontSize: "12px",
    },
  },
  submitButton: {
    padding: "16px 24px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    border: "none",
    borderRadius: "14px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    marginTop: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 25px rgba(102, 126, 234, 0.5)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
  },
  submitIcon: {
    fontSize: "18px",
  },
  snackbar: {
    position: "fixed",
    bottom: "24px",
    right: "24px",
    color: "white",
    padding: "16px 24px",
    borderRadius: "14px",
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
    animation: "slideIn 0.3s ease-out",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "14px",
    fontWeight: "500",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    zIndex: 1000,
  },
  snackbarIcon: {
    fontSize: "20px",
  },
};

// Add keyframes for animations
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @media (max-width: 640px) {
    .form-row {
      grid-template-columns: 1fr;
    }
  }
`;
document.head.appendChild(styleSheet);

export default CreateAdmin;